import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
interface AccordionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}
export function Accordion({
  title,
  children,
  defaultOpen = false
}: AccordionProps) {
  const [open, setOpen] = useState(defaultOpen);
  return <div className="overflow-hidden rounded-2xl border border-blue-100 bg-white/90 shadow-sm backdrop-blur" data-id="element-17" data-mp="28d88y50uo2l1">
      <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left" data-id="element-18" data-mp="2i4ut4qv61bzx">
        <span className="text-sm font-bold text-blue-950 sm:text-base" data-id="element-19" data-mp="2s323gquy8vsy">
          {title}
        </span>
        <motion.span animate={{
        rotate: open ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 text-blue-700" data-id="element-20" data-mp="11qcnztrojxsm">
          <ChevronDownIcon size={16} data-id="element-21" data-mp="3g5f02p6ptqky" />
        </motion.span>
      </button>
      <AnimatePresence initial={false} data-id="element-22" data-mp="3l2nlcyn5uaqf">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: "auto",
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="overflow-hidden" data-id="element-23" data-mp="3l1400tmnd9hs">
            <div className="px-4 pb-4 pt-0" data-id="element-24" data-mp="3lxcdsrnzlj6">{children}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}